/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./checkbox-group-form-item.vue?vue&type=template&id=2009ee79&scoped=true&"
import script from "./checkbox-group-form-item.vue?vue&type=script&lang=js&"
export * from "./checkbox-group-form-item.vue?vue&type=script&lang=js&"
import style0 from "./checkbox-group-form-item.vue?vue&type=style&index=0&id=2009ee79&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2009ee79",
  null
  
)

export default component.exports